/**
 * Created by prog2 on 25/10/2018.
 */

export default {
    message: {
        title: 'KATHEDRALE VON VALENCIA',
        preferVisitRead: '',
        preferVisitListten: '',
        downloadAudio: '(Downloading)',
        download:'Downloading',
        errorDownload: 'Hi hagut un error en la descàrrega.',
        cancelDownload: 'Has cancel·lat la descàrrega.',
        initDownload: 'Bitte warten Sie',
        endDownload: 'Download abgeschlossen. Viel Vergnügen!',
        retry: 'Reintentar',
        noConnection: '',
        titleMap: '',
        map: 'Plano1.png',
        menuItems: [
            {
                idImages: 1,
                title: 'Grußwort',
                author: 'Bitte verwenden Sie Kopfhörer',
                description: '',
                // audio: require('./../../assets/audio/ESP/1.mp3')
                audio: '1.mp3'
            },
            {
                idImages: 2,
                title: 'Kapelle des hl. Sebastian',
                author: 'Fuß des Schiffs',
                description: '',
                audio: '2.mp3'

            },
            {
                idImages: 3,
                title: 'Kapelle des hl. Apostels Petrus',
                author: 'Rechtes Seitenschiff',
                description: '',
                audio: '3.mp3'

            },
            {
                idImages: 4,
                title: 'Kapelle des hl. Franz von Borgia',
                author: 'Rechtes Seitenschiff',
                description: '',
                audio: '4.mp3'

            },
            {
                idImages: 5,
                title: 'Das schräge Fenster',
                author: '',
                description: '.',
                audio: '5.mp3'

            },
            {
                idImages: 6,
                title: 'Hochaltar',
                author: 'Hauptkapelle',
                description: '',
                audio: '6.mp3'

            },
            {
                idImages: 7,
                title: 'Musizierende Engel',
                author: 'Hauptkapelle',
                description: '',
                audio: '7.mp3'

            },
            {
                idImages: 8,
                title: 'Laternenturm',
                author: 'Vierung',
                description: '',
                audio: '8.mp3'

            },
            {
                idImages: 9,
                title: 'Almosentor',
                author: 'Rechter Arm des Querschiffs',
                description: '',
                audio: '9.mp3'

            },
            {
                idImages: 10,
                title: 'Chorumgang + Orgel',
                author: 'Chorumgang',
                description: '',
                audio: '10.mp3'

            },
            {
                idImages: 11,
                title: 'Auferstehung',
                author: 'Kapellen des Chorumgangs',
                description: '',
                audio: '11.mp3'

            },
            {
                idImages: 12,
                title: 'Christus des guten Todes',
                author: 'Kapellen des Chorumgangs',
                description: '',
                audio: '12.mp3'

            },
            {
                idImages: 13,
                title: 'Sitzende Gottesmutter ',
                author: 'Kapellen des Chorumgangs',
                description: '',
                audio: '13.mp3'

            },
            {
                idImages: 14,
                title: 'Hl. Dionysius und hl. Margarete',
                author: 'Kapellen des Chorumgangs',
                description: '',
                audio: '14.mp3'

            },
            {
                idImages: 15,
                title: 'Aposteltor',
                author: 'Linker Arm des Querschiffs',
                description: '',
                audio: '15.mp3'

            },
            {
                idImages: 16,
                title: 'Fortsetzung der Besichtigung',
                author: 'Linkes Seitenschiff',
                description: '',
                audio: '16.mp3'

            },
            {
                idImages: 17,
                title: 'Monstranz',
                author: 'Museum: Erdgeschoss',
                description: '',
                audio: '17.mp3'

            },
            {
                idImages: 18,
                title: 'Böse Schächer + Anbetung ',
                author: 'Museum: Erdgeschoss',
                description: '',
                audio: '18.mp3'

            },
            {
                idImages: 19,
                title: 'Modelle',
                author: 'Museum: Zweites Obergeschoss',
                description: '',
                audio: '19.mp3'

            },
            {
                idImages: 20,
                title: 'Apostel',
                author: 'Museum: Zweites Obergeschoss',
                description: '',
                audio: '20.mp3'

            },
            {
                idImages: 21,
                title: 'Hl. Thomas + Entschlafung',
                author: 'Museum: Zweites Obergeschoss',
                description: '',
                audio: '21.mp3'

            },
            {
                idImages: 22,
                title: 'Reliquienschatz',
                author: 'Museum: Zweites Obergeschoss',
                description: '',
                audio: '22.mp3'

            },
            {
                idImages: 23,
                title: 'Verspottung',
                author: 'Museum: Zweites Obergeschoss',
                description: '',
                audio: '23.mp3'

            },
            {
                idImages: 24,
                title: 'Verbindungsgang + Barockkunst',
                author: 'Museum: Zweites Obergeschoss',
                description: '',
                audio: '24.mp3'

            },
            {
                idImages: 25,
                title: 'Ausgrabungsstätte',
                author: 'Museum: Untergeschoss',
                description: '',
                audio: '25.mp3'

            },
            {
                idImages: 26,
                title: 'Chorbücher + Letzte Abendmahl',
                author: 'Museum: Erdgeschoss',
                description: '',
                audio: '26.mp3'

            },
            {
                idImages: 27,
                title: 'Der Heilige Kelch',
                author: 'Kapelle des Heiligen Kelches',
                description: '',
                audio: '27.mp3'

            },
            {
                idImages: 28,
                title: 'Kapelle des Heiligen Kelches',
                author: 'Kapelle des Heiligen Kelches',
                description: '',
                audio: '28.mp3'

            },
            {
                idImages: 29,
                title: 'El Micalet ',
                author: 'Fuß des Schiffs',
                description: '',
                audio: '29.mp3'

            },
            {
                idImages: 30,
                title: 'Credits',
                isCredits:true,
                author: '',
                description: 'Trama Media für die Kathedrale von Valencia.<br><br>© Kathedrale von Valencia.<br><br>Alle Rechte vorbehalten.<br><br>',
                audio: '',
                idCreditImage: 30,
            },


        ]

    }
};



// WEBPACK FOOTER //
// ./src/data/i18n/deutsch.js